import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_USER_FROM_IMPORT_UPDATE:
      return action.listsUserFromImport
    default:
      return state
  }
}